const initialState = {
  eventInfo: {},
  isFetching: true,
}

const handlers = {
  FETCH_EVENT_INFO: (state) => ({ ...state, isFetching: true }),
  FETCH_EVENT_INFO_SUCCESS: (state, { payload }) => ({
    ...state,
    eventInfo: payload.eventInfo,
    isFetching: false,
  }),
  FETCH_EVENT_INFO_FAILURE: (state) => ({ ...state, isFetching: false }),
  FETCH_HORSE_RACING_EVENT_INFO: (state) => ({ ...state, isFetching: true }),
  FETCH_HORSE_RACING_EVENT_INFO_SUCCESS: (state, { payload }) => ({
    ...state,
    eventInfo: payload.eventInfo,
    isFetching: false,
  }),
  FETCH_HORSE_RACING_EVENT_INFO_FAILURE: (state) => ({
    ...state,
    isFetching: false,
  }),
}

export default function eventInfo(state = initialState, action) {
  const { type } = action

  return handlers[type] ? handlers[type](state, action) : state
}
